import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-xhr-backend'
import detector from 'i18next-browser-languagedetector'

const resources = {
  en: { translation: require('../i18n/en.json') },
  es: { translation: require('../i18n/es.json') },
  'pt-BR': { translation: require('../i18n/pt-br.json') },
}

i18n
  .use(Backend)
  .use(detector)
  .use(initReactI18next)
  .init({
    initImmediate: false,
    fallbackLng: 'en',
    detection: {
      order: ['localStorage', 'cookie'],
      lookupLocalStorage: 'lang',
    },
    resources,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  })

export default i18n
